"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textbox = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shapes = require("../../skybase-core/shapes");

var _sbNonEditableControl = require("../sb-non-editable-control");

var _sbNumericTextbox = require("../sb-numeric-textbox");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NOOP = function NOOP() {};

var getTextboxClasses = function getTextboxClasses(_ref) {
  var hasError = _ref.hasError,
      type = _ref.type;
  return {
    'sb-control': true,
    'sb-textbox': true,
    'has-error': hasError,
    number: type === 'number'
  };
};

var getInputType = function getInputType(type) {
  return type === 'password' ? 'password' : 'text';
};

var Textbox = /*#__PURE__*/function (_Component) {
  _inherits(Textbox, _Component);

  var _super = _createSuper(Textbox);

  function Textbox(props) {
    var _this;

    _classCallCheck(this, Textbox);

    _this = _super.call(this, props);
    _this.state = {
      value: props.value
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.fireOnChange = _this.fireOnChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Textbox, [{
    key: "fireOnChange",
    value: function fireOnChange(event, value, values) {
      var type = this.props.type; // TODO: numeric fields need some extra care, investigate a possibility of storing numeric values as strings in store

      if (type === 'number') {
        if (parseFloat(this.props.value) !== parseFloat(value) && (!value || !value.startsWith('.'))) {
          this.props.onChange(event, values);
        }
      } else {
        this.props.onChange(event, values);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(event, values) {
      var onChange = this.props.onChange;
      onChange(event, values);
    }
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      var onBlur = this.props.onBlur;
      onBlur(event);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      var _this$props = this.props,
          filterValue = _this$props.filterValue,
          onKeyDown = _this$props.onKeyDown;
      var key = event.key;

      if (filterValue) {
        var result = filterValue(key);

        if (!result) {
          event.preventDefault();
          event.stopPropagation();
        }
      }

      if (onKeyDown) {
        onKeyDown(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          decimalPlaces = _this$props2.decimalPlaces,
          editable = _this$props2.editable,
          hasError = _this$props2.hasError,
          type = _this$props2.type,
          formatter = _this$props2.formatter,
          filterValue = _this$props2.filterValue,
          id = _this$props2.id,
          inputRef = _this$props2.inputRef,
          rest = _objectWithoutProperties(_this$props2, ["className", "decimalPlaces", "editable", "hasError", "type", "formatter", "filterValue", "id", "inputRef"]);

      var cssClasses = getTextboxClasses(this.props);
      var value = this.state.value;
      /**
       * If editable=false was set, render just the value.
       */

      if (editable === false) {
        var nonEditableControlClass = (0, _classnames.default)(className, {
          'has-error': hasError
        });
        return /*#__PURE__*/_react.default.createElement(_sbNonEditableControl.SbNonEditableControl, {
          value: value,
          inputRef: inputRef,
          id: id,
          className: nonEditableControlClass
        });
      }

      var inputClass = (0, _classnames.default)(cssClasses, className, {
        'has-error': hasError
      });
      /**
       * Provide SbNumericTextbox component when type is number.
       */

      if (type === 'number') {
        return /*#__PURE__*/_react.default.createElement(_sbNumericTextbox.SbNumericTextbox, _extends({}, rest, {
          id: id,
          inputRef: inputRef,
          value: value,
          onChange: this.onChange,
          onBlur: this.onBlur,
          className: inputClass
        }));
      }

      return /*#__PURE__*/_react.default.createElement("input", _extends({}, rest, {
        id: id,
        ref: inputRef,
        value: value,
        onChange: this.onChange,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        type: getInputType(type),
        className: inputClass
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var value = props.value;
      var stateValue = state.value;

      if (value !== stateValue) {
        return {
          value: value
        };
      }

      return null;
    }
  }]);

  return Textbox;
}(_react.Component);

exports.Textbox = Textbox;

_defineProperty(Textbox, "propTypes", {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  decimalPlaces: _propTypes.default.number,
  editable: _propTypes.default.bool,
  filterValue: _propTypes.default.func,
  formatter: _propTypes.default.func,
  hasError: _propTypes.default.bool,
  onBlur: _propTypes.default.func,
  onChange: _propTypes.default.func,
  type: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  inputRef: _shapes.PropTypeRef
});

_defineProperty(Textbox, "defaultProps", {
  className: null,
  id: null,
  decimalPlaces: 0,
  editable: true,
  filterValue: null,
  formatter: null,
  hasError: false,
  onBlur: NOOP,
  onChange: NOOP,
  type: 'text',
  value: undefined,
  inputRef: NOOP
});
//# sourceMappingURL=textbox.js.map